import React, { useEffect, useState } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import DataService from "../../../../../Service";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import CustomInput from '../../../../../Components/CustomInput';
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import { Divider, InputLabel } from "@material-ui/core";
import Select from '@material-ui/core/Select';
import FormHelperText from "@material-ui/core/FormHelperText";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from '@material-ui/core/FormControl';
import AddToListModal from '../../../../../../src/Components/FormGenerator/addToListModal';
import { useDispatch, useSelector } from 'react-redux';
import { TOGGLE_GROWING_LIST_POPUP } from '../../../../../../src/Redux/actions';
import { showSnackbar } from "../../../../../../src/Components/Snackbar/SnackbarActions";

const useStyles = makeStyles((theme) => ({
    formWrapper: {
        background: "#fff",
        width: "500px",
        padding: theme.spacing(3),
    },
    dialog_title: {
        marginLeft: '1.5rem',

    }, inputLabel: {
        color: '#a9a9a9 !important',
        textTransform: "inherit",
    },
    inputField: {
        paddingTop: '10.5px !important',
        paddingBottom: '10.5px !important'
    },

}));

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;

    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>{children}</Typography>
            {
                onClose ? (
                    <IconButton
                        aria-label="close"
                        className={classes.closeButton}
                        onClick={onClose}
                    >
                        <CloseIcon />
                    </IconButton>
                ) : null
            }
        </MuiDialogTitle >
    );
});

const MasterTemplateModal = (props) => {
    const { isOpen, onClose, fetchMasterTemplate, currentSelection, inputValue, setInputValue, dropDownValue, setDropDownValue } = props;
    const classes = useStyles();
    const dispatch = useDispatch();
    const [submitClickFlag, setSubmitClickFlag] = React.useState(false);
    const [rateCardtypeArray, setRateCardTypeArray] = useState([]);
    const [serviceTypeData, setServiceTypeData] = useState([
        { id: 1, name: 'internal', value: 'Internal' },
        { id: 2, name: 'external', value: 'External' }
    ]);
    const [showModal, setShowModal] = useState(true);
    const [postData, setPostData] = useState({});

    const { showGrowingDropdownModal } = useSelector((state) => state.commonReducer)


    const fetchServiceType = () => {
        DataService.getData({}, "fetch_service").then((res) => {
            if (res?.success) {
                setRateCardTypeArray(res);

            }
        }).catch((error) => {
        })
    }

    useEffect(() => {
        fetchServiceType();
    }, [showGrowingDropdownModal])

    useEffect(() => {
        if (currentSelection) {
            setDropDownValue({
                service_type: currentSelection.service_type || "",
                service: currentSelection.service || ""
            });
            setInputValue(currentSelection?.template_name || "")

        }
    }, [currentSelection])

    const handleInputValue = (value, name) => {
        setInputValue(value);
    }

    const handleDropDownValue = (event) => {
        const { name, value } = event?.target;
        if (value === 'Add New') {
            event.preventDefault();
            setPostData({ drop_down: 'Service', field_name: 'name' });
            setShowModal(true);
            dispatch({ type: TOGGLE_GROWING_LIST_POPUP, payload: true });
        } else {
            setDropDownValue({ ...dropDownValue, [name]: value });
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        var formData = new FormData(e.target)
        if (!inputValue || !dropDownValue?.service_type || !dropDownValue?.service) {
            setSubmitClickFlag(true);
        } else {
            if (currentSelection) {
                formData.append('master_template_id', currentSelection?.id);
                DataService.updateData(formData, "", 'update_master_template').then((res) => {
                    if (res?.success) {
                        fetchMasterTemplate();
                        onClose();
                        dispatch(showSnackbar("success", [res?.message], 5000));
                    }
                }).catch((error) => {
                    setSubmitClickFlag(true)
                })
            } else {
                DataService.createData(formData, "create_master_template").then((res) => {
                    if (res?.success) {
                        fetchMasterTemplate();
                        onClose();
                        dispatch(showSnackbar("success", [res?.message], 5000));
                    }
                }).catch((error) => {
                    dispatch(showSnackbar("error", error.errors, 5000));
                    setSubmitClickFlag(true)
                })
            }
        }

    }

    return (
        <>
            <Dialog maxWidth={"sm"} fullWidth={true} open={isOpen} onClose={onClose}
                aria-labelledby="base-station-manage">
                <DialogTitle id="customized-dialog-title" className={classes.dialog_title}>
                    {currentSelection ? 'Update' : 'Creating new'} master template
                </DialogTitle>
                <Divider />
                <DialogContent style={{ margin: '0px auto' }}>
                    <div className={classes.formWrapper}>
                        <form onSubmit={handleSubmit}>
                            <div>
                                <Grid style={{ marginBottom: '2rem' }} container alignItems={"center"}>
                                    <Grid item xs={3}>
                                        <Typography variant="h2">Service</Typography>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <FormControl size="small" style={{ width: '100%' }} variant="outlined">
                                            {!Boolean(dropDownValue?.service_type) && <InputLabel className={classes.inputLabel} shrink={false} id="service_type"><Typography variant="h2" >Select service</Typography></InputLabel>}
                                            <Select
                                                error={submitClickFlag && !dropDownValue?.service_type ? true : false}
                                                labelId="service"
                                                id="service"
                                                autoFocus
                                                name='service_type'
                                                placeholder={'Select service'}
                                                onChange={handleDropDownValue}
                                                value={dropDownValue?.service_type || ''}
                                            >
                                                {serviceTypeData?.length && serviceTypeData?.map((data, index) => {
                                                    return (
                                                        <MenuItem name={data?.name} key={index} value={data?.name}><Typography variant="h2">{data?.value}</Typography></MenuItem>
                                                    )
                                                })}
                                            </Select>
                                            <FormHelperText style={{ marginLeft: '2px' }}
                                                error={submitClickFlag && !dropDownValue?.service ? true : false}>{submitClickFlag && !dropDownValue?.service_type ? 'Service is requied.' : null}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                </Grid>

                                <Grid style={{ marginBottom: '2rem' }} container alignItems={"center"}>
                                    <Grid item xs={3}>
                                        <Typography variant="h2">Service type</Typography>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <FormControl size="small" style={{ width: '100%' }} variant="outlined">
                                            {!Boolean(dropDownValue?.service) && <InputLabel className={classes.inputLabel} shrink={false} id="service_type"><Typography variant="h2" >Select service type</Typography></InputLabel>}
                                            <Select
                                                error={submitClickFlag && !dropDownValue?.service ? true : false}
                                                labelId="service_type"
                                                id="service_type"
                                                name='service'
                                                placeholder={'Select service type'}
                                                onChange={handleDropDownValue}
                                                value={dropDownValue?.service || ''}
                                                InputLabelProps={{ shrink: false }} >
                                                {rateCardtypeArray?.services?.length && rateCardtypeArray?.services?.map((data, index) => {
                                                    return (
                                                        <MenuItem name={data} key={index} value={data}><Typography variant="h2">{data}</Typography></MenuItem>
                                                    )
                                                })}
                                                {rateCardtypeArray?.services?.length && <MenuItem key="Add New" value="Add New">+ Add New</MenuItem>}

                                            </Select>
                                            <FormHelperText style={{ marginLeft: '2px' }}
                                                error={submitClickFlag && !dropDownValue?.service ? true : false}>{submitClickFlag && !dropDownValue?.service ? 'Service type is required.' : null}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                </Grid>



                                <Grid style={{ marginBottom: '2rem' }} container alignItems={"center"}>
                                    <Grid item xs={3}>
                                        <Typography variant="h2">Template
                                            name</Typography>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <Typography variant="h2">
                                            <CustomInput error={submitClickFlag && inputValue == "" ? true : false}
                                                helperText={submitClickFlag && inputValue == "" ? "Template name is requied" : ""}
                                                variant="outlined"
                                                id="template_name"
                                                name={'template_name'}
                                                parentcall={(value, name) => {
                                                    handleInputValue(value, name)
                                                }}
                                                size="small"
                                                placeholder='Template name'
                                                value={inputValue}
                                                InputLabelProps={{ shrink: false }} />
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1} alignItems={"center"} justify={"flex-end"}
                                    style={{ marginTop: 20 }}>
                                    <Grid item xs={2} style={{ marginRight: '1rem' }}>
                                        <Button disableElevation type="button" style={{ textTransform: 'capitalize' }}
                                            onClick={onClose}
                                            variant={"contained"}>Cancel</Button>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Button disableElevation type="submit" style={{ textTransform: 'capitalize' }}
                                            variant={"contained"}
                                            color="secondary">
                                            {currentSelection ? "Update" : "Create"}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </div>
                        </form>
                    </div>
                    {showModal && <AddToListModal postData={postData} />}
                </DialogContent>

            </Dialog >
        </>
    )
}

export default MasterTemplateModal;
